import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDiscoveryPath = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 21 20",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 3.57031C8.5 3.03988 8.71071 2.53117 9.08579 2.1561C9.46086 1.78103 9.96957 1.57031 10.5 1.57031C11.0304 1.57031 11.5391 1.78103 11.9142 2.1561C12.2893 2.53117 12.5 3.03988 12.5 3.57031C12.5 4.10075 12.2893 4.60945 11.9142 4.98453C11.5391 5.3596 11.0304 5.57031 10.5 5.57031C9.96957 5.57031 9.46086 5.3596 9.08579 4.98453C8.71071 4.60945 8.5 4.10075 8.5 3.57031Z",
			stroke: "currentColor",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 16.5703C8.5 16.0399 8.71071 15.5312 9.08579 15.1561C9.46086 14.781 9.96957 14.5703 10.5 14.5703C11.0304 14.5703 11.5391 14.781 11.9142 15.1561C12.2893 15.5312 12.5 16.0399 12.5 16.5703C12.5 17.1007 12.2893 17.6095 11.9142 17.9845C11.5391 18.3596 11.0304 18.5703 10.5 18.5703C9.96957 18.5703 9.46086 18.3596 9.08579 17.9845C8.71071 17.6095 8.5 17.1007 8.5 16.5703Z",
			stroke: "currentColor",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 9.97021C15.5 9.43978 15.7107 8.93107 16.0858 8.556C16.4609 8.18093 16.9696 7.97021 17.5 7.97021C18.0304 7.97021 18.5391 8.18093 18.9142 8.556C19.2893 8.93107 19.5 9.43978 19.5 9.97021C19.5 10.5006 19.2893 11.0094 18.9142 11.3844C18.5391 11.7595 18.0304 11.9702 17.5 11.9702C16.9696 11.9702 16.4609 11.7595 16.0858 11.3844C15.7107 11.0094 15.5 10.5006 15.5 9.97021Z",
			stroke: "currentColor",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.5 9.97021C1.5 9.43978 1.71071 8.93107 2.08579 8.556C2.46086 8.18093 2.96957 7.97021 3.5 7.97021C4.03043 7.97021 4.53914 8.18093 4.91421 8.556C5.28929 8.93107 5.5 9.43978 5.5 9.97021C5.5 10.5006 5.28929 11.0094 4.91421 11.3844C4.53914 11.7595 4.03043 11.9702 3.5 11.9702C2.96957 11.9702 2.46086 11.7595 2.08579 11.3844C1.71071 11.0094 1.5 10.5006 1.5 9.97021Z",
			stroke: "currentColor",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 5.83691L10.5 13.8369",
			stroke: "currentColor",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.5 7.96388V4.77028C3.5 4.18118 3.97756 3.70361 4.56667 3.70361H8.5",
			stroke: "currentColor",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1819 7.96388V4.77028C17.1819 4.18118 16.7043 3.70361 16.1152 3.70361H12.5",
			stroke: "currentColor",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDiscoveryPath;
